import instanceQuery from '../../../graphql/queries/bank/BankConfigQuery.graphql';
import defaultQuery from '../../../graphql/queries/bank/BankConfigDefault.graphql';
import mutationQuery from '../../../graphql/mutations/bank/BankConfigMutation.graphql';
import fragment from '../../../graphql/fragments/bank/BankConfigFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const BankConfig = {
  type: 'BankConfig',
  title: 'Bank Configuration',
  formTitle: 'Bank Configuration',
  formUrl: '/Bank/BankConfig/',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'BANK_CONFIGURATION',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default BankConfig;
